/**
 * Plafonne l'option « fond de boîtier transparent » au nombre de montres
 * réellement MARQUÉES dans le panier, c'est-à-dire portant la mention
 * « Fond de boîtier : Transparent » posée par la case de la fiche produit ou
 * par l'encart du panier.
 *
 * C'est la mention qui fait foi, pas l'éligibilité de la gamme : une montre
 * éligible sans la mention n'ouvre aucun droit à l'option. Sans cela, retirer
 * une montre marquée alors qu'il reste une montre éligible non marquée
 * laisserait une option payée que l'atelier ne saurait sur quelle montre
 * monter. L'option est reconnue par son tag « option ».
 *
 * Deux effets :
 *  - le sélecteur de quantité de la ligne option se bloque au plafond
 *    (bouton + désactivé et attribut max posé, ce qui bloque aussi la saisie) ;
 *    l'option s'ajoute donc par l'encart, qui marque la montre au passage ;
 *  - si la quantité dépasse déjà le plafond (montre marquée retirée, option
 *    ajoutée deux fois), elle est ramenée au plafond et le client en est
 *    informé.
 *
 * L'état fait foi côté serveur : les quantités et les lignes sont relues dans
 * /cart.js juste avant d'agir, et les corrections visent la CLÉ de la ligne,
 * jamais sa position. L'encart d'upsell modifie le panier de son côté : une
 * position relevée dans la page serait périmée et pourrait viser une montre.
 *
 * Script classique, sans import : il ne dépend d'aucun module du thème.
 */
(function () {
  if (window.__oclOptionPlafond) return;
  window.__oclOptionPlafond = true;

  var TAG_OPTION = 'option';
  var NOM_REFERENCE = 'Montre';
  var NOM_MENTION = 'Fond de boîtier';
  var VALEUR_MENTION = 'Transparent';
  var MESSAGE_MAX = 'Une option par montre. Ajoutez-la depuis l’encart ci-dessus.';
  var MESSAGE_MAX_SEUL = 'Une option par montre.';
  var MESSAGE_CORRECTION = 'La quantité de l\'option a été ajustée au nombre de montres concernées.';
  var CORRECTIONS_MAX = 5;

  var cacheTags = {};
  var corrections = 0;
  var enCours = false;

  function racine() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    return '/';
  }

  function urlChangement() {
    if (window.Theme && Theme.routes && Theme.routes.cart_change_url) return Theme.routes.cart_change_url;
    return racine() + 'cart/change';
  }

  /** Tags d'un produit, lus une seule fois puis gardés en mémoire. */
  function tagsProduit(handle) {
    if (cacheTags[handle]) return Promise.resolve(cacheTags[handle]);

    return fetch(racine() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (reponse) {
        return reponse.ok ? reponse.json() : null;
      })
      .then(function (produit) {
        var tags = [];
        if (produit && produit.tags && produit.tags.length) {
          tags = produit.tags.map(function (tag) {
            return String(tag).toLowerCase().trim();
          });
        }
        cacheTags[handle] = tags;
        return tags;
      })
      .catch(function () {
        cacheTags[handle] = [];
        return [];
      });
  }

  /** Une montre porte-t-elle la mention « Fond de boîtier : Transparent » ? */
  function estMarquee(article) {
    return !!(
      article.properties && String(article.properties[NOM_MENTION] || '') === VALEUR_MENTION
    );
  }

  function lirePanier() {
    return fetch(racine() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (reponse) {
        return reponse.ok ? reponse.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  /**
   * État réel du panier : quota de montres marquées, total de l'option et
   * lignes d'option, repérées par leur clé.
   */
  function etatPanier() {
    return lirePanier().then(function (panier) {
      if (!panier || !panier.items) return null;

      var articles = panier.items;

      return Promise.all(
        articles.map(function (article) {
          return tagsProduit(article.handle);
        })
      ).then(function (tousLesTags) {
        var quota = 0;
        var totalOption = 0;
        var lignesOption = [];
        var montresPresentes = [];

        articles.forEach(function (article, index) {
          var tags = tousLesTags[index] || [];

          if (tags.indexOf(TAG_OPTION) > -1) {
            var reference = '';
            if (article.properties && article.properties[NOM_REFERENCE]) {
              reference = String(article.properties[NOM_REFERENCE]);
            }
            totalOption += article.quantity;
            lignesOption.push({ cle: article.key, quantite: article.quantity, reference: reference });
          } else if (estMarquee(article)) {
            quota += article.quantity;
            montresPresentes.push(article.product_title);
          }
        });

        return {
          quota: quota,
          totalOption: totalOption,
          lignesOption: lignesOption,
          montresPresentes: montresPresentes,
        };
      });
    });
  }

  function lignesOptionAffichees() {
    var lignes = Array.prototype.slice.call(document.querySelectorAll('[data-ref="cart-item"][data-product-handle]'));

    return lignes.filter(function (ligne) {
      var tags = cacheTags[ligne.getAttribute('data-product-handle')] || [];
      return tags.indexOf(TAG_OPTION) > -1;
    });
  }

  function quantiteAffichee(ligne) {
    var champ = ligne.querySelector('[data-ref="quantity-selector-input"]');
    if (champ) {
      var saisie = parseInt(champ.value, 10);
      if (!isNaN(saisie)) return saisie;
    }
    var attribut = parseInt(ligne.getAttribute('data-quantity'), 10);
    return isNaN(attribut) ? 0 : attribut;
  }

  /**
   * Renvoyer vers l'encart n'a de sens que s'il propose une montre : quand
   * toutes les montres concernées sont déjà équipées, il ne reste que le
   * bandeau de confiance, sans bouton d'ajout.
   */
  function texteMessage() {
    return document.querySelector('[data-ref="add-addon-button"]') ? MESSAGE_MAX : MESSAGE_MAX_SEUL;
  }

  function afficherMessage(ligne, visible) {
    var note = ligne.querySelector('[data-ocl-option-max]');

    if (!visible) {
      if (note) note.remove();
      return;
    }

    if (note) {
      var attendu = texteMessage();
      if (note.textContent !== attendu) note.textContent = attendu;
      return;
    }

    note = document.createElement('div');
    note.setAttribute('data-ocl-option-max', '');
    note.textContent = texteMessage();
    note.style.cssText = 'margin-top:4px;font-size:11px;line-height:1.4;color:#7A5E38;';

    var champ = ligne.querySelector('[data-ref="quantity-selector-input"]');
    var ancre = champ ? champ.closest('quantity-selector') : null;
    if (ancre && ancre.parentNode) {
      ancre.parentNode.insertBefore(note, ancre.nextSibling);
    } else {
      ligne.appendChild(note);
    }
  }

  function notifier(message) {
    document.dispatchEvent(
      new CustomEvent('toast:open', { detail: { type: 'info', message: message } })
    );
  }

  /** Brider les sélecteurs de quantité des lignes d'option visibles. */
  function briderAffichage(etat) {
    lignesOptionAffichees().forEach(function (ligne) {
      var champ = ligne.querySelector('[data-ref="quantity-selector-input"]');
      if (!champ) return;

      var quantite = quantiteAffichee(ligne);
      var autres = etat.totalOption - quantite;
      var plafond = Math.max(1, etat.quota - autres);

      champ.setAttribute('max', plafond);

      var atteint = quantite >= plafond;
      var boutonPlus = ligne.querySelector('button[name="plus"]');
      if (boutonPlus) boutonPlus.disabled = atteint;

      afficherMessage(ligne, atteint);
    });
  }

  /**
   * Choisit la ligne d'option à rogner. On retire en priorité une option
   * orpheline, c'est-à-dire dont la mention « Montre : ... » désigne une montre
   * qui n'est plus au panier : sinon l'atelier garderait une option étiquetée
   * au nom d'une montre supprimée. À défaut, on prend la dernière ligne.
   */
  function choisirCible(etat) {
    for (var i = 0; i < etat.lignesOption.length; i++) {
      var ligne = etat.lignesOption[i];
      if (ligne.reference && etat.montresPresentes.indexOf(ligne.reference) === -1) {
        return ligne;
      }
    }
    return etat.lignesOption[etat.lignesOption.length - 1];
  }

  /**
   * Ramène une ligne d'option pour que le total tienne dans le quota.
   * La ligne est visée par sa clé : l'encart d'upsell peut avoir déplacé les
   * positions entre-temps.
   */
  function corriger(etat) {
    if (corrections >= CORRECTIONS_MAX) return;

    var cible = choisirCible(etat);
    if (!cible || !cible.cle) return;

    var surplus = etat.totalOption - etat.quota;
    var nouvelleQuantite = Math.max(0, cible.quantite - surplus);

    enCours = true;
    corrections += 1;

    fetch(urlChangement(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: cible.cle, quantity: nouvelleQuantite }),
    })
      .then(function (reponse) {
        return reponse.json();
      })
      .then(function (panier) {
        if (!panier || panier.errors) {
          enCours = false;
          return;
        }

        notifier(MESSAGE_CORRECTION);
        window.location.reload();
      })
      .catch(function (erreur) {
        console.error(erreur);
        enCours = false;
      });
  }

  function appliquer() {
    if (enCours) return;

    etatPanier().then(function (etat) {
      if (!etat || !etat.lignesOption.length) return;

      if (etat.totalOption > etat.quota) {
        corriger(etat);
        return;
      }

      briderAffichage(etat);
    });
  }

  /**
   * L'encart d'upsell enchaîne plusieurs requêtes sur le panier. On laisse
   * passer sa séquence avant de relire l'état, sinon on corrigerait sur une
   * photo périmée.
   */
  function appliquerBientot() {
    setTimeout(appliquer, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', appliquerBientot);
  } else {
    appliquerBientot();
  }

  document.addEventListener('cart:updated', appliquerBientot);
  document.addEventListener('cart:open', appliquerBientot);
})();
